import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SearchIcon } from 'app/agriculture/icons';
import { SkeletonButton } from 'app/agriculture/components/Button/SkeletonButton';
import { DeviceIcon } from 'app/agriculture/icons/devices/DeviceIcon';
import { ContentBoxSkeleton } from 'app/agriculture/components/ContentBox/ContentBoxSkeleton';
import { WeatherStationListTableSkeleton } from 'app/agriculture/routes/Devices/WeatherStationList/components/WeatherStationListTableSkeleton';

export function WeatherStationListSkeleton() {
    return (
        <ContentBoxSkeleton
            title="Weather Stations"
            Icon={(props) => <DeviceIcon {...props} deviceType="Weather Station" />}
            variant="xl"
        >
            <ContentBox.Section className="WeatherStationList__header">
                <SkeletonButton startIcon={<SearchIcon color="#ccc" />} variant="textonly" />
            </ContentBox.Section>
            <ContentBox.Section scrollable>
                <WeatherStationListTableSkeleton />
            </ContentBox.Section>
        </ContentBoxSkeleton>
    );
}
